import { ChangeDetectionStrategy, Component, InputSignal, TemplateRef, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BlockDirective, ElemDirective } from '@rt-tools/core';
import { RtPopoverDirective } from '@rt-tools/ui-kit-v2';

type IRouterLinkTarget = readonly unknown[] | string;

const BEM_BLOCK: string = 'sc-info-icon';

@Component({
    selector: 'sc-info-icon',
    templateUrl: './info-icon.component.html',
    styleUrl: './info-icon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // angular
        RouterLink,

        // rt-tools
        BlockDirective,
        ElemDirective,

        // rt-tools ui-kit
        RtPopoverDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class InfoIconComponent {
    public readonly link: InputSignal<IRouterLinkTarget> = input.required<IRouterLinkTarget>();
    public readonly popoverContent: InputSignal<TemplateRef<unknown> | null> = input<TemplateRef<unknown> | null>(null);
    public readonly popoverContext: InputSignal<unknown> = input<unknown>(null);
    public readonly ariaLabel: InputSignal<string> = input<string>($localize`:@@hintAriaLabel:Подробнее о параметре`);

    protected onClick(event: MouseEvent): void {
        // Prevent the click from bubbling to a parent <label> which would
        // otherwise focus/activate the bound form control.
        event.stopPropagation();
    }
}
